@if (current$ | async; as item) {
  <button
    class="button active"
  [disabled]="
    isDisabled(item) ||
    ((isInEditMode$ | async) && item.active && disabled !== true)
  "
    (click)="toggle(item)"
    >
    <!-- {{ 'organization.' + (item.active ? 'disable' : 'enable') | cxTranslate }} -->
    @if (item.active) {
      <cx-icon
        class="u-pointer"
        [type]="iconTypes.BLACK_ICON_DELETE ">
      </cx-icon>
    } @else {
      {{ 'organization.enable' | cxTranslate }}
    }
  </button>
}
